function useClaimNow() {
  return () => {
    // TODO: Implement
    return Promise.resolve();
  };
}

export default useClaimNow;
